import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import MainLayout from '@/components/layout/MainLayout';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useRoleAccess } from '@/features/auth/hooks/useRoleAccess';import { MunicipalListsFilters } from '../components/MunicipalListsFilters';
import { MunicipalListsTable } from '../components/MunicipalListsTable';
import { QueryStateMessage } from '../components/QueryStateMessage';
import { useMunicipalLists } from '../hooks/usePreRegistrationQueries';
import type { MunicipalListFilterValues } from '../types/pre-registration.types';
import { PRE_REGISTRATION_EDIT_ROLES, preRegistrationRoutes } from '../utils/routes.utils';

export const MunicipalListsPage: React.FC = () => {
  const { hasRole } = useRoleAccess();
  const [filters, setFilters] = useState<MunicipalListFilterValues>({});
  const { data: lists = [], isLoading, isError, isFetching, refetch } = useMunicipalLists(filters);
  const hasFilters = Object.values(filters).some((value) => value !== undefined);

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Listados municipales</h1>
            <p className="mt-2 text-gray-600">
              Listados de preinscripción remitidos por municipios y comisiones municipales
            </p>
          </div>
          {hasRole(PRE_REGISTRATION_EDIT_ROLES) && (
            <Button asChild>
              <Link to={preRegistrationRoutes.newMunicipalList}>
                <Plus className="mr-2 h-4 w-4" />
                Nuevo listado
              </Link>
            </Button>
          )}
        </div>

        <Card>
          <CardContent className="pt-6">
            <MunicipalListsFilters values={filters} onChange={setFilters} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>
              Listados
              {!isLoading && !isError && (
                <span className="ml-2 text-sm font-normal text-gray-500">({lists.length})</span>
              )}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <QueryStateMessage
              isLoading={isLoading}
              isError={isError}
              isEmpty={lists.length === 0}
              errorMessage="No se pudieron cargar los listados municipales."
              emptyMessage={
                hasFilters
                  ? 'No hay listados municipales que coincidan con los filtros.'
                  : 'Todavía no se cargó ningún listado municipal.'
              }
              onRetry={() => refetch()}
            >
              <div className={`overflow-x-auto ${isFetching ? 'opacity-60' : ''}`}>
                <MunicipalListsTable items={lists} />
              </div>
            </QueryStateMessage>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default MunicipalListsPage;
